<template>
  <div>
    <v-breadcrumb>
      <button v-can:edit-exploitation class="primary-action flex-12 btn-icon enregistrer" type="button" @click="save(true)">Enregistrer</button>
    </v-breadcrumb>

    <v-module title='Informations générales'>
      <v-field-text v-validate.initial='"required"' v-model='nom' :required='true' label='Nom de l"exploitation' placeholder='ex : Exploitation céréalière' name='nom' />
      <v-row>
        <v-field-integer v-model="sau" label="Surface Agricole Utile (en ha)" placeholder="ex : 120" name="sau" v-validate.initial="'required|min_value:0'" :tooltip="true"/>
        <v-field-integer v-model="objectif" label="Objectif de revenu (net annuel, en €)" placeholder="ex : 18 000" name="objectif" v-validate.initial="'required|min_value:0'" :tooltip="true"/>
        <v-field-integer v-model="dpb" label="Aides découplées (en €/ha)" placeholder="ex : 100" name="dpb" v-validate.initial="'min_value:0'" :tooltip="true"/>
      </v-row>
    </v-module>

    <v-module title='Localisation'>
      <v-row>
        <v-field-text v-model="adresse" label="N° et adresse" placeholder="ex : 3 Rue des fleurs" name="adresse" v-validate />
        <v-field label="Code postal et ville" :error="errors.first('id_ref_commune')" name="id_ref_commune" :tooltip="getTooltipMessage('commune')">
          <SelectCommune v-model="id_ref_commune" :initialCommune="initialCommune" v-validate:id_ref_commune.initial="'required'" data-vv-as="commune" name="id_ref_commune" />
        </v-field>
      </v-row>
    </v-module>
  </div>
</template>

<script>
import SelectCommune from '@/components/SelectCommune'
import mixinConfirmation from '@/mixins/confirmation'
import mixinTooltip from '@/mixins/tooltip'
import {mapActions} from "vuex";

export default {
  name: 'ExploitationInformation',
  inject: ['$validator'],
  mixins: [mixinConfirmation, mixinTooltip],

  components: {
    SelectCommune
  },

  data () {
    return Object.assign({}, this.$store.state.exploitation.information)
  },

  computed: {
    initialCommune: function () {
      if (!this.id_ref_commune) {
        return []
      }
      return [{
        id_ref_commune: this.id_ref_commune,
        nom: this.commune_nom,
        code_postal: this.commune_cp
      }]
    }
  },

  methods: {
    ...mapActions('alerte', ['alerte']),
    save (clicked = false) {
      let p = new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$store.dispatch('saveExploitation', this.$data)
              .then(() => {
                this.$store.dispatch('success', { message: 'Données enregistrées' })
                this.clearflags()
                resolve()
              })
              .catch((error) => {
                reject(new Error("Erreur lors de l'enregistrement" + error))
              })
          } else {
            reject(new Error('Des erreurs sont présentes'))
          }
        })
      })

      if (clicked) {
        p.catch(err => {
          this.alerte( {
            title: 'Erreur',
            message: err.message || err,
            okTest: 'Ok'
          })
        })
      }
      return p
    }
  }
}
</script>
